module.exports = __webpack_public_path__ + "img/auth-flow.3b554703.png";